import { render, staticRenderFns } from "./MyAccountView.vue?vue&type=template&id=41057170&"
import script from "./MyAccountView.vue?vue&type=script&lang=js&"
export * from "./MyAccountView.vue?vue&type=script&lang=js&"
import style0 from "./MyAccountView.vue?vue&type=style&index=0&id=41057170&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MyAccountView.vue"
export default component.exports